module.exports = __webpack_public_path__ + "img/amazon-alexa.635f36fb.svg";